<template lang="html"> 
    <section>
        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 grid-margin stretch-card">
                <total-revenue-card/>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 grid-margin stretch-card">
                <total-orders-card/>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 grid-margin stretch-card">
                <total-pending-orders-card />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 grid-margin stretch-card">
                <waiting-time-card/>
            </div>
        </div>
        <div class="row">
            <div class="col-12 grid-margin">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-9">
                                
                            </div>
                            <div class="col-md-3">
                                <b-button class="btn btn-primary btn-block"
                                    v-b-modal.modalRestaurantSelect
                                >
                                    <i class="mdi mdi-plus"></i>Add New Order
                                </b-button>
                                <b-modal id="modalRestaurantSelect" 
                                        title="Select Restaurant"
                                        hide-footer
                                        centered>
                                   
                                        <b-button class="mt-3" block
                                            v-for="r in restaurants"
                                            @click="handleBtnAddNewOrder(r)"> 
                                            {{ r.restaurantName }} 
                                        </b-button>
                                    
                                </b-modal>
                            </div>

                        </div>
                        <b-tabs class="tab-minimal tab-minimal-success">
                            <b-tab>
                                <template slot="title">
                                    <i class='mdi mdi-file-document-box'></i> Current Orders
                                </template>
                                    <current-orders/>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>      
        </div>
    </section>
</template> 

<script lang="js">
import { mapState } from'vuex'
import RestaurantChangedBase from '../Bases/RestaurantChangedBase'
import TotalOrdersCard from '../Cards/TotalOrdersCard'
import TotalRevenueCard from '../Cards/TotalRevenueCard'
import TotalPendingOrdersCard from '../Cards/TotalPendingOrdersCard'
import WaitingTimeCard from '../Cards/WaitingTimeCard'
import CurrentOrders from './CurrentOrders'
import OrderMessages from '../../services/ordermessages'
export default{
    name: 'ordercontrol',
    extends: RestaurantChangedBase,
    components: {
        TotalOrdersCard,
        TotalRevenueCard,
        TotalPendingOrdersCard,
        WaitingTimeCard,
        CurrentOrders
    },
    computed : {
        ...mapState({
           restaurants : state => state.restaurants.restaurants
        }),
    },
   
    methods: {
        handleBtnAddNewOrder (restaurant) {
            this.$router.push({ name: 'orderbyphoneaddform', params: { id: restaurant.restaurantId }});
        }
    },
    async created() {
        await this.$store.dispatch('ordermessages/getCurrentOrdersAction');
        this.setAction('ordermessages/getCurrentOrdersAction');
    }

}
</script>

<style lang="scss">
   
</style>